export default __webpack_public_path__ + "static/media/gold-large.d485d405.svg";